import { AnalyticsBrowser } from '@segment/analytics-next'
import type { Analytics, User } from '@segment/analytics-next'
import type { AnalyticsEvents } from 'types/events/events'

const analytics = new AnalyticsBrowser()

export type AnalyticsService = () => {
  user: () => Promise<User>
  load: () => Promise<Analytics>
  page: () => void
  track: <K extends keyof AnalyticsEvents>(event: K, properties: AnalyticsEvents[K]) => unknown
  identify: (traits: Record<string, unknown>) => unknown
}

export const useSegment: AnalyticsService = () => {
  const user = (): Promise<User> => {
    return analytics.user()
  }

  const track = (event: string, properties: Record<string, unknown>): void => {
    analytics.track(event, properties)
  }

  const identify = (traits: Record<string, unknown>): void => {
    analytics.identify(traits)
  }

  const load = (): Promise<Analytics> => {
    const promise = new Promise<Analytics>((resolve, reject) => {
      analytics
        .load({ writeKey: import.meta.env.PUBLIC_SEGMENT_WRITE_KEY })
        .then(([instance]) => resolve(instance))
        .catch((error) => reject(error))
    })

    return promise
  }

  const page = (): void => {
    analytics.page()
  }

  return {
    user,
    page,
    load,
    track,
    identify,
  }
}
